/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import Flickity from 'flickity';

function flickityLogoTicker () {
    const blocks = document.querySelectorAll( '.wp-block-leanpathblocks-logo-ticker' )
    if ( !blocks.length ) return

    blocks.forEach( ( block ) => {
        const items = block.querySelectorAll( '.logo-ticker-cell' )
        if ( !items.length ) return

        const holder = block.querySelector( '.logo-ticker-slider' )
        const flickity = new Flickity( holder, {
            accessibility: true,
            resize: true,
            wrapAround: true,
            prevNextButtons: false,
            pageDots: false,
            percentPosition: true,
            setGallerySize: true,
            draggable: false,
        } );

        flickity.x = 0;

        let requestId;

        play();
        
        function play() {
            flickity.x -= 1;
          
            flickity.settle(flickity.x);
          
            requestId = window.requestAnimationFrame(play);
        }

        // Pause on hover/focus
        // block.addEventListener('mouseenter', () => pause());

        // Unpause on mouse out / defocus
        // block.addEventListener('mouseleave', () => play());
          
    } )
}

flickityLogoTicker ()